import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './Input.css';

const Textarea = ({ 
  className = '', 
  ...props 
}) => {
  let theme = 'dark';
  try {
    const themeContext = useTheme();
    theme = themeContext.theme || 'dark';
  } catch (error) {
    // Fallback to dark theme if ThemeProvider is not available
    theme = 'dark';
  }
  
  const baseClasses = 'unified-textarea';
  const themeClass = theme === 'dark' ? 'unified-input-dark' : 'unified-input-light';
  const combinedClasses = `${baseClasses} ${themeClass} ${className}`.trim();

  return (
    <textarea
      className={combinedClasses}
      {...props}
    />
  );
};

export default Textarea;

